module.exports = app => {
  const schemas = {};
  return schemas;
};
